/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice } from "@reduxjs/toolkit";
import {
  defaultAddToDictionary,
} from "../defaultReducers";

export const faqListsFaqsSlice = createSlice({
  name: "faqListsFaqs",
  initialState: { dictionary: {} },
  reducers: {
    addToDictionary: defaultAddToDictionary,
  },
});

export const actions = faqListsFaqsSlice.actions;

export default faqListsFaqsSlice.reducer;
